import { useId } from 'react';

interface WinnerRibbonBannerProps {
  width?: number;
  className?: string;
}

/** Octro-style WINNER ribbon — green capsule with gold WINNER text (no side scroll tails) */
export default function WinnerRibbonBanner({ width = 118, className = '' }: WinnerRibbonBannerProps) {
  const uid = useId().replace(/:/g, '');
  const viewMinX = 44;
  const viewMinY = 18;
  const viewWidth = 172;
  const viewHeight = 36;
  const height = Math.round(width * (viewHeight / viewWidth));
  const textX = viewMinX + viewWidth / 2;
  const textY = viewMinY + viewHeight / 2 + 2;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`${viewMinX} ${viewMinY} ${viewWidth} ${viewHeight}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`tp-winner-ribbon-banner ${className}`.trim()}
      aria-label="Winner"
      role="img"
    >
      <defs>
        <linearGradient id={`${uid}-body`} x1="130" y1="10" x2="130" y2="58" gradientUnits="userSpaceOnUse">
          <stop stopColor="#86EFAC" />
          <stop offset="0.28" stopColor="#22C55E" />
          <stop offset="0.62" stopColor="#16A34A" />
          <stop offset="1" stopColor="#15803D" />
        </linearGradient>
        <linearGradient id={`${uid}-gold`} x1="0" y1="0" x2="1" y2="0">
          <stop stopColor="#FFF59D" />
          <stop offset="0.45" stopColor="#FFD54F" />
          <stop offset="1" stopColor="#FFB300" />
        </linearGradient>
        <linearGradient id={`${uid}-shine`} x1="130" y1="18" x2="130" y2="44" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFFFFF" stopOpacity="0.28" />
          <stop offset="1" stopColor="#FFFFFF" stopOpacity="0" />
        </linearGradient>
        <filter id={`${uid}-shadow`} x="-12%" y="-20%" width="124%" height="140%">
          <feDropShadow dx="0" dy="1.5" stdDeviation="1.6" floodColor="#000" floodOpacity="0.38" />
        </filter>
      </defs>

      <g filter={`url(#${uid}-shadow)`}>
        <path
          d="M 42 54 L 42 34 C 42 34 78 18 130 14 C 182 18 218 34 218 34 L 218 54 C 182 60 78 60 42 54 Z"
          fill={`url(#${uid}-body)`}
          stroke={`url(#${uid}-gold)`}
          strokeWidth="1.45"
          strokeLinejoin="round"
        />
        <path
          d="M 50 50 L 50 36 C 82 26 178 26 210 36 L 210 50 C 178 54 82 54 50 50 Z"
          fill={`url(#${uid}-shine)`}
        />
      </g>

      <text
        x={textX}
        y={textY}
        textAnchor="middle"
        dominantBaseline="middle"
        fill="#FFE566"
        stroke="#14532D"
        strokeWidth="0.9"
        paintOrder="stroke fill"
        fontFamily="'Arial Black', Impact, 'Segoe UI', system-ui, sans-serif"
        fontSize="20"
        fontWeight="900"
        letterSpacing="0.06em"
      >
        WINNER
      </text>
    </svg>
  );
}
